import React from 'react';
import { FiMenu } from 'react-icons/fi';
import { animateScroll as scroll } from 'react-scroll';
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  LogoDot,
  NavMenu,
  NavCta,
} from './NavbarElements';

const Navbar = ({ toggle }) => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const linkProps = {
    smooth: true,
    duration: 500,
    spy: true,
    exact: 'true',
    offset: -72,
  };

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo onClick={toggleHome} to='/'>
          Cloutch<LogoDot />
        </NavLogo>
        <MobileIcon onClick={toggle}>
          <FiMenu />
        </MobileIcon>
        <NavMenu>
          <NavItem>
            <NavLinks to='services' {...linkProps}>
              Services
            </NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to='products' {...linkProps}>
              Products
            </NavLinks>
          </NavItem>
          <NavItem>
            <NavLinks to='about' {...linkProps}>
              About
            </NavLinks>
          </NavItem>
        </NavMenu>
        <NavCta to='contact' {...linkProps}>
          Get in touch
        </NavCta>
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
